module.exports = __webpack_public_path__ + "static/person-2-70x70-a188fb0888b3a2ca0d2df5eded3dbf34.png";